import React from "react";
import { StoryCard } from "../../atoms/story-card";
import { connect } from "react-redux";
import "./styles.m.css";
import PropTypes from "prop-types";
import assetify from "@quintype/framework/assetify";
import Rchive from "../../../../assets/images/rchives.png";
import { Link } from "@quintype/components";

const LatestMagazines = ({ relatedStories, config, color = "transparent" }) => {
  // const style = {
  //   "border-left": `3px solid ${color}`
  // };
  return relatedStories.length ? (
    <div styleName="related-stories">
      <Link href="/magissues">
        <img src={assetify(Rchive)} styleName="archive-button" />
      </Link>
      {relatedStories &&
        relatedStories.slice(0, 3).map((item, index) => {
          return (
            <StoryCard
              story={item.story}
              key={`{${item.id}${index}}`}
              config={config}
              className="related-story-cards"
              showAuthor
              showSection
              imageAspectRatio="320, 380"
              mobileAspectRatio="320, 380"
              desktopAspectRatio="320, 380"
            />
          );
        })}
    </div>
  ) : null;
};

export default connect(state => ({ config: state.qt.config }))(LatestMagazines);

LatestMagazines.propTypes = {
  relatedStories: PropTypes.array,
  config: PropTypes.object,
  color: PropTypes.string
};
